export default {
  playItem: {} // 游玩项目
};
